import { getCommonDisabledState } from '../../middleware/toolbar-middleware';
import { IBaseFeatureState } from './base-feature-state.interface';

export class BaseFeatureState implements IBaseFeatureState {
    /**
     * ui是否置灰，包括通用的比如是否为查看态，是否打开历史记录等，以及ui自定义的置灰逻辑
     * 推荐在ui的controller文件中的shouldDisabled回调中调用该方法
     */
    public shouldDisabled(id: string) {
        return getCommonDisabledState(id) || this.getCustomDisabledState();
    }

    /**
     * ui自定义的置灰状态
     * 推荐在ui的feature文件中重写该方法
     */
    protected getCustomDisabledState() {
        return false;
    }
}
